import React, { useRef, useEffect } from 'react';

// User Profile Dropdown Component for Mobile
// Shows logout option and credits used when profile icon is clicked
const UserProfileDropdown = ({ user, creditsUsed, onLogout, onClose }) => {
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [onClose]);

  if (!user) return null;

  return (
    <div className="profile-dropdown-overlay" onClick={onClose}>
      <div className="profile-dropdown" ref={dropdownRef} onClick={(e) => e.stopPropagation()}>
        <div className="profile-dropdown-header">
          <div className="profile-dropdown-user">
            <img 
              src={user.picture} 
              alt={user.name || user.email}
              className="profile-dropdown-avatar"
            />
            <div className="profile-dropdown-info">
              <div className="profile-dropdown-name">{user.name || 'User'}</div>
              <div className="profile-dropdown-email">{user.email}</div>
            </div>
          </div>
        </div>
        
        <div className="profile-dropdown-content">
          <div className="profile-dropdown-item">
            <span className="profile-dropdown-label">Credits Used:</span>
            <span className="profile-dropdown-value">{creditsUsed}</span>
          </div>
          
          <div className="profile-dropdown-divider"></div>
          
          <button 
            className="profile-dropdown-logout"
            onClick={(e) => {
              e.stopPropagation();
              onLogout();
              onClose();
            }}
            type="button"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserProfileDropdown;

